/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument.ts";

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationKey =
  () =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/show-on-student-document",
      },
    ] as const;

export type PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationKey =
  ReturnType<
    typeof patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationKey
  >;

export function patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationKey();
  return mutationOptions<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["disciplineId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ classModuleId, disciplineId }) => {
      return patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument(
        classModuleId,
        disciplineId,
        config,
      );
    },
  });
}

/**
 * @description Inverte a flag ShowOnStudentDocument da Disciplina no Módulo. Se a configuração ainda não existir, ela é criada. Retorna o estado atualizado da configuração. **(Requer Authorization para autenticação)**
 * @summary Alternar 'Exibir no documento do aluno' (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/show-on-student-document}
 */
export function usePatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500
      >,
      {
        classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["classModuleId"];
        disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["disciplineId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationKey();

  const baseOptions =
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500
      >,
      {
        classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["classModuleId"];
        disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["disciplineId"];
      },
      TContext
    >;

  return useMutation<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["disciplineId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams["disciplineId"];
    },
    TContext
  >;
}
